export default __webpack_public_path__ + "static/media/promo_08.0b085955.jpg";